import { ORDER_STATUS } from '@vindr/services/constants/order.constant';
import { PERMISSIONS } from '@vindr/services/constants/permissions.constant';
import { ParamsGetOrders, ResponseGetOrders } from '@vindr/services/apis/order.api';
import keycloak from '@vindr/services/keycloak';
import { Button } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Updater } from 'use-immer';
import CreateOrderModal from './CreateOrderModal';
import CreateReception from './CreateReception';

const CreateOrder = ({
  selectedRowKeys,
  setSelectedRowKeys,
  params,
}: {
  selectedRowKeys: ResponseGetOrders['data'];
  setSelectedRowKeys: Updater<ResponseGetOrders['data']>;
  params: ParamsGetOrders;
}) => {
  const { t } = useTranslation('Vindoc');
  const [popupAddOrder, setPopupAddOrder] = useState(false);
  const [popupAddReception, setPopupAddReception] = useState({ open: false, action: null });

  return (
    <div className="flex items-end space-x-2 overflow-auto pt-3 pb-6">
      <Button
        className={`batch-button flex items-center
          justify-center text-base`}
        size="small"
        onClick={() => setPopupAddOrder(true)}
        style={{ width: 90 }}
        disabled={!keycloak.hasOneOfPerm([PERMISSIONS.order.create])}
      >
        {t('Add Order')}
      </Button>
      <Button
        className={`batch-button flex items-center
        justify-center text-base`}
        size="small"
        onClick={() => setPopupAddReception({ open: true, action: 'receive' })}
        style={{ width: 90 }}
        disabled={
          !keycloak.hasOneOfPerm([PERMISSIONS.order.update]) || //? Disabled when no have Order Create Permission
          !selectedRowKeys.length || //? Disabled when no have selected row
          selectedRowKeys.some(
            //? Disabled when have selected row with status is not NEW or CANCEL
            (item) => ![ORDER_STATUS.NEW, ORDER_STATUS.CANCEL].includes(item.status)
          )
        }
      >
        {t('Receive')}
      </Button>
      <Button
        className={`batch-button flex items-center
        justify-center text-base`}
        size="small"
        onClick={() => setPopupAddReception({ open: true, action: 'changeDevice' })}
        style={{ width: 110 }}
        disabled={
          !keycloak.hasOneOfPerm([PERMISSIONS.order.update]) || //? Disabled when no have Order Create Permission
          !selectedRowKeys.length //? Disabled when no have selected row
        }
      >
        {t('Change Device')}
      </Button>
      {popupAddOrder ? (
        <CreateOrderModal
          visible={popupAddOrder}
          onCancel={() => setPopupAddOrder(false)}
          onFinish={() => setPopupAddOrder(false)}
        />
      ) : null}
      {popupAddReception?.open ? (
        <CreateReception
          action={popupAddReception.action}
          open={popupAddReception.open}
          onCancel={() => setPopupAddReception({ open: false, action: null })}
          {...{ selectedRowKeys, setSelectedRowKeys, params }}
        />
      ) : null}
    </div>
  );
};

export default CreateOrder;
